import React from 'react'
import AdminSettings from '../../components/AdminSettings/AdminSettings';
import UserPage from "../../common/UserPage/UserPage";
import Footer from '../../common/Footer/Footer';

function AdminSettingsPage() {
  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <UserPage />
      <div style={{ flex: 1 }}>
        <AdminSettings />
      </div>
      <Footer />
    </div>
  )
}

export default AdminSettingsPage